import comp from "./TermWiseHistoryList";
export default comp;
